module.exports = __webpack_public_path__ + "static/solu-1-ee91d744f89f1ffd26fa3ddc3993858c.jpg";